import React, { useEffect, useState } from "react";
import { Tag, Divider, Spin } from "antd";
import { useLanguage } from "../../../../../../context/LanguageContext";
import { PositionSecured } from "../../../../../../models/Security";
import Corridor from "../../../../../../models/Corridor";
import SecurityService from "../../../../../../services/SecurityService";

interface GridProps {
  sweepId: string;
}

interface Classe {
  name: string
  color: string
}

const CorridorColorReferences: React.FC<GridProps> = ({ sweepId }) => {
  const { language } = useLanguage();
  const [classes, setClasses] = useState<Classe[]>([])
  const [loading, setLoading] = useState<boolean>(true);
  const capitalize = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);


  const fetchClasses = async () => {
    try {
      const response = await SecurityService.getSecurityClasses(sweepId);
      // Verifica que la respuesta sea un array antes de asignarla al estado
      if (Array.isArray(response)) {
        setClasses(response);
      } else {
        console.warn("Respuesta inesperada del servidor:", response);
        setClasses([]);
      }
    } catch (error) {
      console.error("Error al obtener las clases:", error);
      setClasses([]);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchClasses()
  }, [])

  return (
    <Spin spinning={loading}>
      {!loading && (
        <div style={{ textAlign: "center" }}>
          <Divider orientation="center">{language === "es" ? "Referencias de Color" : "Color References"}</Divider>
          <Tag color={classes[0].color}>{language === "es" ? "Seguro" : capitalize(classes[0].name)}</Tag>
          <Tag color={classes[1].color}>{language === "es" ? "Precaución" : capitalize(classes[1].name)}</Tag>
          <Tag color={classes[2].color}>{language === "es" ? "Riesgoso" : capitalize(classes[2].name)}</Tag>
          {/* <Tag color="#bfbfbf" style={{ color: "#333333" }} >{language === "es" ? "Ignorada" : "Ignored"}</Tag> */}
        </div>
      )}
    </Spin>
  );
};

export default CorridorColorReferences;
